import { QueryKey } from 'constants/reactQuery';

export const couponCatalogQueryKey = {
  couponCatalogs: [QueryKey.CouponCatalog] as const,
  couponCatalog: (id: number) => [...couponCatalogQueryKey.couponCatalogs, id] as const,

  coupon: (couponId: number) => [QueryKey.Coupon, couponId] as const,
  coupons: (couponIds: number[]) => [QueryKey.Coupon, couponIds] as const,
};
